var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "31px",
    viewBox: "0 0 24 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2074EF2F-2D47-49CD-9E30-ECC7790B3019") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A74E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6FE6",
    offset: "31.4717061%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D69EA",
    offset: "66.8206292%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8358ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Build-Stream-Icon",
    transform: "translate(-20.000000, -16.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.619048, 16.476190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3681942,10.114958 C20.3681942,10.1911485 20.3060467,10.253296 20.2295574,10.253296 L15.4364295,10.253296 L15.4364295,10.2482166 L6.53349767,10.2482166 L6.53349767,10.253296 L2.52856769,10.253296 C2.45237722,10.253296 2.39022969,10.1911485 2.39022969,10.114958 L2.39022969,6.99772176 C2.39022969,6.9080859 2.60296545,6.56776844 3.12912792,6.26001867 C4.42048179,5.50498599 5.50298413,4.42278245 6.2604071,3.1287395 C6.56785808,2.60257703 6.90787675,2.39014006 6.99781139,2.39014006 L20.2295574,2.39014006 C20.3060467,2.39014006 20.3681942,2.45228758 20.3681942,2.52847806 L20.3681942,10.114958 Z M12.7817143,27.9477124 C12.7817143,28.0236041 12.7198655,28.0857516 12.6433763,28.0857516 L10.1147488,28.0857516 C10.0385584,28.0857516 9.97641083,28.0236041 9.97641083,27.9477124 L9.97641083,12.6435854 C9.97641083,12.6417927 9.97611204,12.6402988 9.97611204,12.6385061 L12.7820131,12.6385061 C12.7820131,12.6402988 12.7817143,12.6417927 12.7817143,12.6435854 L12.7817143,27.9477124 Z M20.2295574,-0.000149393091 L6.99781139,-0.000149393091 C5.79519701,-0.000149393091 4.80382446,0.884257703 4.19669094,1.92253968 C3.64662558,2.86222222 2.86201307,3.64743231 1.92262932,4.19660131 C0.884048553,4.80403361 -5.97572362e-05,5.79540616 -5.97572362e-05,6.99772176 L-5.97572362e-05,10.114958 C-5.97572362e-05,11.5114846 1.13233987,12.6435854 2.52856769,12.6435854 L7.58612138,12.6435854 L7.58612138,27.9477124 C7.58612138,29.3439402 8.71822222,30.4760411 10.1147488,30.4760411 L12.6433763,30.4760411 C14.0399029,30.4760411 15.1720037,29.3439402 15.1720037,27.9477124 L15.1720037,12.6435854 L20.2295574,12.6435854 C21.626084,12.6435854 22.7584837,11.5114846 22.7584837,10.114958 L22.7584837,2.52847806 C22.7584837,1.13225023 21.626084,-0.000149393091 20.2295574,-0.000149393091 L20.2295574,-0.000149393091 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildStream);
export default __webpack_public_path__ + "static/media/build-stream.72a6d9d915de5a547d33b1c36b49a749.svg";
export { ForwardRef as ReactComponent };